import React from 'react'

export default function SectionTitle({title}) {
  return (
    <div className='section-title' >{title}</div>
  )
}
